/* eslint-disable react/display-name */
import { Box, CssBaseline, ThemeProvider } from '@material-ui/core';
import Container from '@material-ui/core/Container';
import clsx from 'clsx';
import React, { useMemo } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Home from './components/@Home';
import Login from './components/@Login';
import Service from './components/@Service';
import Status from './components/@Status';
import { DialogProvider } from './components/Common/DialogContext';
import {
  SnackbarAlert,
  SnackBarProvider,
} from './components/Common/SnackBarContext';
import Footer from './components/Skeleton/Footer';
import Navbar from './components/Skeleton/Nav';
import NoMatch from './components/Skeleton/NoMatch';
import { useThemeType } from './contexts/ThemeTypeContext';
import {
  mainishStyles,
  rootStylesDark,
  rootStylesLight,
  themeDark,
  themeLight,
} from './styling';

const routeList = [
  {
    path: '/',
    component: Home,
  },
  {
    path: '/layanan',
    component: Service,
  },
  {
    path: '/layanan/2',
    component: Service,
  },
  {
    path: '/login',
    component: Login,
  },
  {
    path: '/status',
    component: Status,
  },
  {
    path: '*',
    component: NoMatch,
  },
];

export default () => {
  const themeHelper = useThemeType();
  const theme = useMemo(
    () => (themeHelper.themeType === 'dark' ? themeDark : themeLight),
    [themeHelper.themeType]
  );
  const classes = mainishStyles();
  const classesDark = rootStylesDark();
  const classesLight = rootStylesLight();
  const classesDendent = useMemo(
    () => (themeHelper.themeType === 'dark' ? classesDark : classesLight),
    [themeHelper.themeType]
  );

  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <SnackBarProvider>
          <DialogProvider>
            <Navbar />
            {/* <div
                style={{
                  height: 65,
                }}
              ></div> */}
            <Box
              boxShadow={3}
              className={clsx(classes.content, {
                [classes.contentShift]: themeHelper.drawerState,
              })}
              minWidth="50vh"
            >
              <Container
                component="main"
                style={{
                  minHeight: '74.2vh',
                  padding: '1%',
                }}
                className={classesDendent.root}
                maxWidth="md"
              >
                <Switch>
                  {routeList.map((route) => (
                    <Route
                      key={route.path}
                      path={route.path}
                      component={route.component}
                      exact
                    />
                  ))}
                </Switch>
              </Container>
            </Box>
            <Footer />
            <SnackbarAlert />
          </DialogProvider>
        </SnackBarProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
};
